import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="ltn__about-us-area pt-120 pb-90 ">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-info-wrap">
			          <div className="section-title-area ltn__section-title-2--- mb-30">
			            <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Latest Development</h6>
			            <h1 className="section-title">Isiri Coconut Grove <h2>Premium Plots for Future Living</h2></h1>
			            <p>AVS helps you own farmland within city reach, combining gated layout planning with legal assurance, smart amenities, and long-term growth potential.</p>
			          </div>
			          <ul className="ltn__list-item-1 ltn__list-item-1-before clearfix">
			            <li> Site Visit Weekends with AVS Experts</li>
			            <li>Personalised Plot Walkthroughs Available</li>
			            <li>Easy Booking & Registration Support</li>
			            <li>Exclusive 7-Acre Gated Community</li>
			          </ul>
			          <ul className="ltn__list-item-2 ltn__list-item-2-before ltn__flat-info">
			            <li><span>5.5+ Guntas 
							{/* <i className="flaticon-bed" /> */}
							</span>
							Average Plot Size
			            </li>
			            <li><span>Clubhouse Access
							{/* <i className="flaticon-clean" /> */}
							</span>
							Recreational Facilities
			            </li>
			            <li><span>Underground Cabling
							{/* <i className="flaticon-car" /> */}
							</span>
							Clutter-Free Power
			            </li>
			            <li><span>LED Street Lights
							{/* <i className="flaticon-square-shape-design-interface-tool-symbol" /> */}
							</span>
							Well-Lit Roads
			            </li>
			          </ul>
			          <ul className="ltn__list-item-2 ltn__list-item-2-before--- ltn__list-item-2-img mb-50">
			            <li>
			              <a href={publicUrl+"assets/img/img-slide/slide-1.jpg"} data-rel="lightcase:myCollection">
			                <img src={publicUrl+"assets/img/img-slide/11.jpg"} alt="Image" />
			              </a>
			            </li>
			            <li>
			              <a href={publicUrl+"assets/img/img-slide/slide-2.jpg"} data-rel="lightcase:myCollection">
			                <img src={publicUrl+"assets/img/img-slide/12.jpg"} alt="Image" />
			              </a>
			            </li>
			            <li>
			              <a href={publicUrl+"assets/img/img-slide/slide-3.jpg"} data-rel="lightcase:myCollection">
			                <img src={publicUrl+"assets/img/img-slide/13.jpg"} alt="Image" />
			              </a>
			            </li>
			          </ul>
			        </div>
			      </div>
			      <div className="col-lg-6 align-self-center">
			        {/* <div className="about-us-img-wrap about-img-right">
			          <img src={publicUrl+"assets/img/others/9.png"} alt="About Us Image" />
			        </div> */}
					<div className="about-us-img-wrap about-img-right">
						<video
							src={publicUrl + "assets/media/AVS-Reel-4.mp4"}
							controls
							autoPlay
							muted
							loop
							style={{ width: "100%", height: "600px" }}
						>
							Your browser does not support the video tag.
						</video>
					</div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default AboutV2